module.exports = __webpack_public_path__ + "img/1.b99deb05.png";